import { get } from 'aws-amplify/api';
import { PRESCRIPTSURE } from '../constants/api-endpoints';
import { getSessionToken } from './service-config'; // Import the helper function
import { COMMERCIAL_SEARCH } from '../constants/commercial-search';
const apiNamePath = PRESCRIPTSURE.COMMERCIAL_API; // API endpoint from constants

const commercialApiService = {
  async commercialProviderFuzzySearch(searchTerm, countyCode) {
    try {
      const sessionToken = await getSessionToken();

      const commercialProviderFuzzySearchOperation = get({
        apiName: apiNamePath,
        path: `/commercial_fuzzy_search`,
        options: {
          headers: {
            Authorization: `Bearer ${sessionToken}`,
          },
          queryParams: {
            search_type: COMMERCIAL_SEARCH.PROVIDER.search_type,
            search_term: searchTerm,
            county_code: encodeURI(countyCode),
          },
        },
      });

      const commercialProviderFuzzySearchResults = (
        await commercialProviderFuzzySearchOperation.response
      ).body.json();

      return commercialProviderFuzzySearchResults;
    } catch (error) {
      console.error('Error fetching commercial plan information:', error);
    }
  },

  async commercialPlanFuzzySearch(searchTerm, countyCode, issuerId) {
    try {
      const sessionToken = await getSessionToken();

      const commercialPlanFuzzySearchOperation = get({
        apiName: apiNamePath,
        path: `/commercial_fuzzy_search`,
        options: {
          headers: {
            Authorization: `Bearer ${sessionToken}`,
          },
          queryParams: {
            search_type: COMMERCIAL_SEARCH.PLAN.search_type,
            search_term: searchTerm,
            county_code: encodeURI(countyCode),
            issuer_id: issuerId,
          },
        },
      });

      const commercialPlanFuzzySearchResults = (
        await commercialPlanFuzzySearchOperation.response
      ).body.json();

      return commercialPlanFuzzySearchResults;
    } catch (error) {
      console.error('Error fetching commercial plan information:', error);
    }
  },

  async commercialDrugFuzzySearch(searchTerm, planId) {
    try {
      const sessionToken = await getSessionToken();

      const commercialDrugFuzzySearchOperation = get({
        apiName: apiNamePath,
        path: `/commercial_fuzzy_search`,
        options: {
          headers: {
            Authorization: `Bearer ${sessionToken}`,
          },
          queryParams: {
            search_type: COMMERCIAL_SEARCH.DRUG.search_type,
            search_term: searchTerm,
            plan_id: planId,
          },
        },
      });

      const commercialDrugFuzzySearchResults = (
        await commercialDrugFuzzySearchOperation.response
      ).body.json();

      return commercialDrugFuzzySearchResults;
    } catch (error) {
      console.error('Error fetching commercial plan information:', error);
    }
  },

  async getCommercialPlanInfo(planId, contractId, countyCode) {
    try {
      const sessionToken = await getSessionToken();
      const commercialPlanInfoOperation = get({
        apiName: apiNamePath,
        path: `/commercial_plan_info`,
        options: {
          headers: {
            Authorization: `Bearer ${sessionToken}`,
          },
          queryParams: {
            plan_id: encodeURI(planId),
            issuer_id: encodeURI(contractId),
            county_code: encodeURI(countyCode),
          },
        },
      });

      const commercialPlanInfo = (
        await commercialPlanInfoOperation.response
      ).body.json();

      return commercialPlanInfo;
    } catch (error) {
      console.error('Error fetching commercial plan information:', error);
    }
  },

  async getFormularyDrugInfo(planId, documentId) {
    try {
      const sessionToken = await getSessionToken();
      const commercialDrugInfoOperation = get({
        apiName: apiNamePath,
        path: `/commercial_get_drug_info`,
        options: {
          headers: {
            Authorization: `Bearer ${sessionToken}`,
          },
          queryParams: {
            plan_id: encodeURI(planId),
            document_id: encodeURI(documentId),
          },
        },
      });

      const commercialDrugInfo = (
        await commercialDrugInfoOperation.response
      ).body.json();

      return commercialDrugInfo;
    } catch (error) {
      console.error('Error fetching commercial drug information:', error);
    }
  },
};

export default commercialApiService;
